import React from 'react';
import { Card } from '@cimpress/react-components';
import { useTranslation } from 'react-i18next';
import { css } from 'emotion';
import { history } from '../../../utils/history';

const listStyle = css({
  marginTop: '10px'
});

const onClickSettings = () => {
  history.push('configurations');
};

function SettingsCard() {
  const { t } = useTranslation();

  return (
    <Card header={t('landingPage:settingsCard:header')} isMinimal>
      <div className="card-text">
        {t('landingPage:settingsCard:manageSettings')}
        <ul className={listStyle}>
          <li>{t('landingPage:settingsCard:manageSubscriptions')}</li>
          <li>{t('landingPage:settingsCard:manageAutoApproval')}</li>
        </ul>
      </div>
      <button className="btn btn-link" onClick={onClickSettings}>
        {t('landingPage:settingsCard:manageSubscriptionsAndApprovalsButton')}
      </button>
    </Card>
  );
}

export default SettingsCard;
